import { render, staticRenderFns } from "./Transcribe.vue?vue&type=template&id=68e2b766&scoped=true"
import script from "./Transcribe.vue?vue&type=script&lang=js"
export * from "./Transcribe.vue?vue&type=script&lang=js"
import style0 from "./Transcribe.vue?vue&type=style&index=0&id=68e2b766&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e2b766",
  null
  
)

export default component.exports